// extracted by mini-css-extract-plugin
export default {"qna":"QnaLink_qna__MORnV","qna_text":"QnaLink_qna_text__BE3OK","qna_icon":"QnaLink_qna_icon__7ShAv"};